import Usuario from '@/api/usuario'
import _ from 'lodash'
import Vue from 'vue'

const state = {
  usuario: null,
  cargando: false,
  guardandoUsuario: false,
  guardandoPersona: false,
  editando: false
}

const getters = {
  cargando: state => {
    return state.cargando
  },
  usuarioSeleccionado: state => {
    return state.usuario
  },
  personaSeleccionada: (state, getters, rootState) => {
    return rootState.persona.persona
  },
  editando: state => {
    return state.editando
  }
}

const actions = {
  obtenerUsuario (context, payload) {
    const { id } = payload

    return new Promise((resolve, reject) => {
      Usuario.obtener(id).then(
        data => {
          data.roles_seleccionados = _.map(data.roles, rol => {
            return rol.id
          })
          context.commit('setearUsuario', data)
          resolve(data)
        },
        error => {
          context.commit('mostrarError', error)
          reject(error)
        }
      )
    })
  },

  actualizarUsuario (context, payload) {
    const datos = payload

    context.commit('cargando', true)
    return new Promise((resolve, reject) => {
      Usuario.guardar(datos).then(
        data => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'Los datos se guardaron correctamente!'
          })
          context.commit('actualizarUsuario', data)
          resolve(data)
        },
        error => {
          context.commit('cargando', false)
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  actualizarSeccion (context, payload) {
    const datos = payload

    datos.id = context.getters.usuarioSeleccionado.id

    return new Promise((resolve, reject) => {
      Usuario.guardar(datos).then(
        data => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'Los datos se guardaron correctamente!'
          })
          context.commit('actualizarUsuario', data)
          resolve(data)
        },
        error => {
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  editar (context, payload) {
    context.commit('editar', payload)
  }
}

const mutations = {
  cargando (state, payload) {
    state.cargando = payload
  },
  ocultarPlacaCargando (state) {
    state.cargando = true
  },
  setearUsuario (state, usuario) {
    state.usuario = usuario
  },
  setearPersona (state, persona) {
    state.usuario.persona = persona
  },
  actualizarUsuario (state, datos) {
    state.cargando = false
    datos.roles_seleccionados = _.map(datos.roles, rol => {
      return rol.id
    })

    state.usuario = _.assign(state.usuario, datos)
  },
  actualizarPersona (state, datos) {
    state.usuario.persona = _.assign(state.usuario.persona, datos)
  },
  editar (state, valor) {
    state.editando = valor
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
